<ng-content select="app-side-menu-group-title"/>
<ng-content select="app-side-menu-group-content"/>
@if(hasDivider()){
	<mat-divider class="divider-outline-variant"/>
}